import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'

const PortableText = loadable(() => import('./PortableText'))

const FormattedList = ({ listItems }) => (
  <ul className="formattedList">
    {listItems.map(item => (
      <li key={item._key} className="formattedListItem">
        <PortableText blocks={item.content} isBasic />
      </li>
    ))}
  </ul>
)

export default FormattedList

FormattedList.propTypes = {
  listItems: PropTypes.array,
}
